module.exports = __webpack_public_path__ + "img/template_placeholder_purple@2x.c94438d.png";